<div class="wallet-container" *ngIf="!loading && wallet">
  <!-- Mode Compact -->
  <div *ngIf="compact" class="card wallet-card-compact">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-wallet mr-2"></i>
          <strong>Wallet :</strong>
          <span [ngClass]="getSoldeClass()" class="ml-2 h5 mb-0">
            {{ formatMontant(wallet?.solde || 0) }}
          </span>
        </div>
        <span class="badge" [ngClass]="getBadgeClass()">
          {{ translateStatut(wallet.statutClient) }}
        </span>
      </div>
      <div *ngIf="hasCreditDisponible()" class="mt-2">
        <small class="text-success">
          <i class="fas fa-plus-circle"></i>
          Crédit disponible : {{ formatMontant(wallet?.creditDisponible || 0) }}
        </small>
      </div>
      <div *ngIf="hasEcheancesEnRetard()" class="mt-2">
        <small class="text-danger">
          <i class="fas fa-exclamation-triangle"></i>
          {{ wallet?.echeancesEnRetard || 0 }} échéance(s) en retard
        </small>
      </div>
    </div>
  </div>

  <!-- Mode Complet -->
  <div *ngIf="!compact" class="card wallet-card-full">
    <div class="card-header bg-primary text-white">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">
          <i class="fas fa-wallet mr-2"></i>
          Wallet Client
        </h5>
        <button 
          class="btn btn-sm btn-light" 
          (click)="recalculateWallet()"
          [disabled]="loading"
          title="Recalculer le wallet">
          <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
        </button>
      </div>
    </div>
    
    <div class="card-body">
      <!-- Solde Principal -->
      <div class="row mb-4">
        <div class="col-md-6">
          <div class="solde-principal">
            <label class="text-muted mb-1">Solde actuel</label>
            <div class="d-flex align-items-center">
              <i class="fas {{ getSoldeIcon() }} {{ getSoldeClass() }} mr-2" style="font-size: 1.5rem;"></i>
              <span [ngClass]="getSoldeClass()" class="h3 mb-0">
                {{ formatMontant(wallet?.solde || 0) }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-right">
          <span class="badge badge-lg" [ngClass]="getBadgeClass()">
            <i class="fas {{ getStatutIcon() }} mr-1"></i>
            {{ translateStatut(wallet.statutClient) }}
          </span>
        </div>
      </div>

      <!-- Message d'état -->
      <div class="alert" 
           [ngClass]="{
             'alert-success': wallet.statutClient === 'A_JOUR',
             'alert-info': wallet.statutClient === 'CREDITEUR',
             'alert-warning': wallet.statutClient === 'DEBITEUR',
             'alert-danger': wallet.statutClient === 'EN_RETARD'
           }">
        <i class="fas fa-info-circle mr-2"></i>
        {{ wallet.messageEtat }}
      </div>

      <!-- Détails financiers -->
      <div class="row mb-3" *ngIf="showDetails">
        <div class="col-md-4">
          <div class="info-box">
            <label class="text-muted"><i class="fas fa-exclamation-circle text-danger mr-1"></i> Dette exigible</label>
            <p class="h5 text-danger mb-0">{{ formatMontant(wallet?.detteExigible || 0) }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info-box">
            <label class="text-muted"><i class="fas fa-clock text-warning mr-1"></i> Dette future</label>
            <p class="h5 text-warning mb-0">{{ formatMontant(wallet?.detteFuture || 0) }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info-box">
            <label class="text-muted"><i class="fas fa-check-circle text-success mr-1"></i> Crédit disponible</label>
            <p class="h5 text-success mb-0">{{ formatMontant(wallet?.creditDisponible || 0) }}</p>
          </div>
        </div>
      </div>

      <!-- Échéances en retard -->
      <div class="alert alert-danger" *ngIf="hasEcheancesEnRetard()">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        <strong>{{ wallet?.echeancesEnRetard || 0 }}</strong> échéance(s) en retard pour un montant de 
        <strong>{{ formatMontant(wallet?.montantEnRetard || 0) }}</strong>
      </div>

      <!-- Prochaine échéance -->
      <div *ngIf="wallet?.prochaineEcheance && (wallet?.montantProchaineEcheance || 0) > 0" class="alert alert-info">
        <i class="fas fa-calendar-alt mr-2"></i>
        Prochaine échéance : <strong>{{ wallet.prochaineEcheance | date:'dd/MM/yyyy' }}</strong> - 
        Montant : <strong>{{ formatMontant(wallet?.montantProchaineEcheance || 0) }}</strong>
      </div>

      <!-- Niveau de risque -->
      <div class="row" *ngIf="showDetails">
        <div class="col-md-6">
          <p class="mb-0">
            <strong>Niveau de risque :</strong>
            <span [ngClass]="getRisqueClass()" class="ml-2">
              <i class="fas fa-circle mr-1"></i>
              {{ translateNiveauRisque(wallet.niveauRisque) }}
            </span>
          </p>
        </div>
        <div class="col-md-6 text-right">
          <p class="mb-0">
            <small class="text-muted">
              <i class="fas fa-sync mr-1"></i>
              Mis à jour le {{ wallet.dateMiseAJour | date:'dd/MM/yyyy à HH:mm' }}
            </small>
          </p>
        </div>
      </div>

      <!-- Dette totale -->
      <hr *ngIf="showDetails">
      <div class="row" *ngIf="showDetails">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <strong>Dette totale (exigible + future) :</strong>
            <span class="h5 mb-0 text-danger">{{ formatMontant((wallet?.detteExigible || 0) + (wallet?.detteFuture || 0)) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- État de chargement -->
<div *ngIf="loading" class="card">
  <div class="card-body text-center py-5">
    <i class="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
    <p class="text-muted">Chargement du wallet...</p>
  </div>
</div>

<!-- Erreur -->
<div *ngIf="error && !loading" class="alert alert-danger">
  <i class="fas fa-exclamation-triangle mr-2"></i>
  {{ error }}
  <button class="btn btn-sm btn-danger ml-2" (click)="loadWallet()">
    <i class="fas fa-redo mr-1"></i> Réessayer
  </button>
</div>

<!-- Aucun wallet -->
<div *ngIf="!loading && !wallet && !error && customerUuid" class="alert alert-info">
  <i class="fas fa-info-circle mr-2"></i>
  Aucun wallet disponible pour ce client.
</div>